export function shortName(name: string) {
  const split = name.trim().split(/\s+/);
  if (split.length < 2) return name;

  return `${split[0]} ${split[1][0].toUpperCase()}.`;
}
